// eslint-disable-next-line no-restricted-imports
import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';

import { API } from 'core/api';
import { useCognitoUser } from 'core/cognito';
import { useToast } from 'core/toast/hooks';

function useCustomIjmondExport(enabled: boolean) {
  const { token } = useCognitoUser();
  const { addToast } = useToast();

  function fetchData() {
    return API.get<Blob, undefined, true>({
      path: '/admin/custom-reports/ijmond',
      token,
      expectFile: true,
      params: undefined,
      version: 1,
      onError: (error) => {
        addToast({ error, severity: 'error' });
      },
    });
  }

  return useQuery<AxiosResponse<Blob>, undefined, any>(['customIjmondReport'], fetchData, {
    staleTime: Number.MAX_VALUE,
    enabled: enabled,
    retry: 0,
    keepPreviousData: true,
    select: ({ data }) => data,
  });
}

export { useCustomIjmondExport };
